<template>
  <div>
    <el-table
      v-loading="moneyUseringLoading"
      :data="moneyUsering.Items"
      style="width: 100%"
    >
      <el-table-column
        type="index"
        :index="useringIndexMethod"
        label="序号"
        width="50"
      ></el-table-column>
      <el-table-column property="UserName" width="160" label="使用人">
      </el-table-column>
      <el-table-column label="会议/活动" align="center" key="MeetingName">
        <template slot-scope="scope">
          <span>{{ scope.row.MeetingName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="使用时间"
        width="130"
        align="center"
        key="CreateDate"
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row.CreateDate | dateformat('YYYY.MM.DD HH:mm') }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination_box">
      <el-pagination
        background
        @size-change="moneyUseringHandleSizeChange"
        @current-change="moneyUseringHandleCurrentChange"
        :current-page.sync="moneyUseringCurrentPage"
        :page-size="moneyUseringQuery.maxResultCount"
        :layout="pagination_layout"
        :total="moneyUsering.TotalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: 'personal',
  data () {
    return {
      moneyUseringLoading: false,
      moneyUseringQuery: {
        maxResultCount: 10,
        skipCount: 0
      },
      moneyUseringCurrentPage: 1,
      moneyUsering: {},
      pagination_layout: 'prev, pager, next'
    }
  },
  props: ['isCompanySystem'],
  methods: {
    getMoneyUseringList: function () {
      const _this = this
      _this.moneyUseringLoading = true
      _this.$api.moneyUsering.getMoneyUseringList(_this.moneyUseringQuery).then(data => {
        _this.moneyUsering = data
        _this.moneyUseringLoading = false
      }).catch(err => {
        _this.moneyUseringLoading = false
        return err
      })
    },
    useringIndexMethod (index) {
      return this.moneyUseringQuery.skipCount + index + 1
    },
    moneyUseringHandleSizeChange (val) {
      this.moneyUseringQuery.maxResultCount = val
      this.getMoneyUseringList()
    },
    moneyUseringHandleCurrentChange (val) {
      this.moneyUseringQuery.skipCount = (val - 1) * this.moneyUseringQuery.maxResultCount
      this.getMoneyUseringList()
    }
  },
  created () {
    this.getMoneyUseringList()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, prev, pager, next, jumper'
    }
  }
}
</script>
